import { toQueryString } from 'Utils/queryString';

const SELECTOR = {
  searchButton: '.modal-booking .form-booking__btn--results',
  categorySelect: '.form-booking__group--category select',
  locationInput: '.form-booking__location',
  locationPlaceIdInput: '.form-booking__location-place-id-input',
  dateInput: '.flatpickr-input'
};

class BookingForm {
  constructor() {
    this.clickHandler = this.clickHandler.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler when the form is submitted
   *
   * @param {Event} event - click event.
   * */
  clickHandler(event) {
    event.preventDefault();
    let serializedFormParams = this._serialiseForm();
    let queryString = toQueryString(serializedFormParams);

    window.location.href = `${window.location.origin}/photographers?${queryString}`;
  }

  // Private Methods

  /**
   * Serialises the form values into request params.
   * */
  _serialiseForm() {
    return ({
      'filter[category_id]': document.querySelector(SELECTOR['categorySelect']).value,
      'filter[date]': document.querySelector(SELECTOR['dateInput']).value,
      'filter[location]': document.querySelector(SELECTOR['locationInput']).value,
      'filter[location_place_id]': document.querySelector(SELECTOR['locationPlaceIdInput']).value
    });
  }

  /**
   * Adds event listeners.
   * */
  _addEventListeners() {
    document.querySelector(SELECTOR['searchButton']).addEventListener('click', this.clickHandler);
  }
}

export default BookingForm;
